var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-list-loading",class:_vm.classSettings},[_c('div',{staticClass:"w-list-loading__circle"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"w-list-loading__label"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }